// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cab9844e","495":"468b1e6c"}[chunkId] + ".chunk.js";
};